import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { getAdminContext } from '@/lib/admin/server'

export const Route = createFileRoute('/_authenticated/admin')({
  beforeLoad: async () => {
    // Server-side admin check — a normal _authenticated session is not enough.
    const ctx = await getAdminContext()
    if (!ctx) throw redirect({ to: '/dashboard' })
    return { adminUser: ctx.user }
  },
  component: AdminLayout,
})

// Navigation for the admin sections lives in the app sidebar (one nav system);
// this layout only guards and lets each page own its header.
function AdminLayout() {
  return <Outlet />
}
